export default function redirectLogin() {
  if (typeof location === 'undefined') {
    return
  }
  location.href = getLoginPath()
}

export function getLoginPath(host?: string) {
  if (!host) {
    if (typeof location !== 'undefined') {
      host = location.href
    } else {
      host = process.env.NEXT_PUBLIC_SITE as string
    }
  }

  const loginPath = `${
    process.env.NEXT_PUBLIC_LOGIN_URL
  }?page=${encodeURIComponent(host)}`
  return loginPath
}
